// extracted by mini-css-extract-plugin
export var container = "productTemplate-module--container--QyaKa";
export var slide_show = "productTemplate-module--slide_show--yzJ1v";
export var product_title = "productTemplate-module--product_title--3WHMm";
export var summary_section = "productTemplate-module--summary_section--1swQt";
export var summary_h1 = "productTemplate-module--summary_h1--sEZi8";
export var summary_text = "productTemplate-module--summary_text--1CoXE";
export var summary_checkout_container = "productTemplate-module--summary_checkout_container--2XImd";
export var app_store_icons_container = "productTemplate-module--app_store_icons_container--2PC_t";